module.exports = __webpack_public_path__ + "media/images/sup-9dd87f75de9d3a058811defcbffe4403.svg";